<template>
  <div class="horse-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Name</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Abbreviation</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(task, i) in tasks" :key="i">
					<td class="name">{{ task.name }}</td>
					<td class="abbreviation">{{ task.abbreviation }}</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', task)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', task)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="tasks.length === 0">
					<td colspan="6">No tasks found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['tasks'],
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Tasks/List.vue